var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.playerList_data && _vm.currThemeObj)?_c('div',{attrs:{"id":"cup_teamDetail_playerList"}},[_c('teamDetail_playerList',{attrs:{"currThemeObj":_vm.currThemeObj,"currCid":_vm.currCid,"currSid":_vm.currSid,"list":_vm.playerList_data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }